export default {
    accessToken: state => {
        return state.accessToken
    },
    isAuthenticated: state => {
        return '' !== state.accessToken
    },
    getIsEventPanelActive: state => {
        return state.isEventPanelActive
    },
    getIsMediaPanelActive: state => {
        return state.isMediaPanelActive
    },
    getMapSettings: state => {
        return state.mapSettings
    },
    getMenuState: state => {
        return state.isMenuActive
    }
}
